import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [{ path: "captures", lazy: page(() => import("./DarkroomPage")), handle: shows("captures") }],
  fullscreen: [{ path: "capture", lazy: page(() => import("./CapturePage")) }],
};
